import React from 'react';
import { MdCloudUpload, MdClose } from "react-icons/md";
import PropTypes from "prop-types";

function FileUpload({setFormData, setErrors, setDisableUploadButton, handleFileUpload, formData, errors}) {


    const handleUpload = (files, type) => {
        if (type === 'file') {
            const docFile = files[0];
            if  (
                docFile &&
                (docFile.type === 'application/pdf' ||
                    docFile.type === 'application/msword' ||
                    docFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
            ) {
                setFormData(prev => ({ ...prev, file: docFile }));
                setErrors(prev => ({ ...prev, file: '' }));
                handleFileUpload(files);
            } else {
                setErrors(prev => ({ ...prev, file: "Only PDF files are allowed" }));
            }
        } 
    };

    const handleFileDelete = (event, fileType) => {
        event.preventDefault();
        if (fileType === 'file') {
            setFormData(prev => ({ ...prev, file: null, title: '' }));
        } else if (fileType === 'files') {
            setFormData(prev => ({ ...prev, files: [], title: '' }));
        }
        setErrors(prev => ({ ...prev, file: '', files: '' }));
        setDisableUploadButton(true)
    };

    return (
        <div style={styles.container}>
            {/* {formData.file?.length && ( */}
                
                <div style={styles.box}>
                <label htmlFor="pdfUpload" className="label-style">Upload Document</label>
                <div
                    style={styles.dropZone}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                        e.preventDefault();
                        handleUpload(Array.from(e.dataTransfer.files), 'file');
                    }}
                >
                    <input
                        type="file"
                        id="pdfUpload"
                        accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        style={{display: 'none'}}
                        onChange={(e) => {
                            e.preventDefault();
                            handleUpload(Array.from(e.target.files), 'file');
                            e.target.value = null;
                        }}
                    />
                    <label htmlFor="pdfUpload" style={styles.label}>
                        <MdCloudUpload size={48}/>
                        <p>{formData?.file?.name || "Add or drag a file"}</p>
                        {formData?.file?.name && (
                            <MdClose
                                size={24}
                                style={styles.deleteIcon}
                                onClick={(e) => handleFileDelete(e, 'file')}
                            />
                        )}
                    </label>
                </div>
                {errors?.file && <p className="error-text">{errors.file}</p>}
            </div>
            {/* )} */}

        </div>
    );
}

FileUpload.propTypes = {

    setFormData: PropTypes.func,
    setErrors: PropTypes.func,
    setDisableUploadButton: PropTypes.func,
    handleFileUpload: PropTypes.func,
    formData: PropTypes.shape({
        file: PropTypes.object,
    }),
    errors: PropTypes.shape({
        file: PropTypes.string,
    }),
}

const styles = {
    container: {
        justifyContent: 'center',
        gap: '20px',
        display: 'flex',
        marginBottom: '20px'
    },
    box: {
        flex: '1 1 300px',
        maxWidth: '400px',
    },
    dropZone: {
        border: '2px dashed #cdcecf',
        borderRadius: '8px',
        padding: '20px',
        textAlign: 'center',
        position: 'relative',
        minHeight: '150px',
    },
    label: {
        cursor: 'pointer',
        fontSize: "1rem",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    progress: {
        marginTop: 10,
        color: "black"
    },
    deleteIcon: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        cursor: 'pointer',
        color: 'red'
    }
};

export default FileUpload;
